import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationCommentsPage } from './operation-comments';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationCommentsPage,
  ],
  imports: [
    IonicPageModule.forChild(OperationCommentsPage),
    SharedModule,
    DirectivesModule,
  ],
})
export class OperationCommentsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-comments/operation-comments.module.ts